import React from 'react';
interface Props {
  title: string;
  availableJobs: OpenJob[];
}

interface OpenJob {
  text: string;
  hostedUrl: string;
  categories?: {
    location?: string;
    [key: string]: any;
  };
}

export function DepartmentBlock({ title, availableJobs }: Props) {
  return availableJobs.length ? (
    <div
      className="flex flex-col items-start gap-2 self-stretch tablet:w-full tablet:max-w-[566px] tablet:flex-grow tablet:break-inside-avoid"
      data-testid="department-block"
    >
      <div className="flex flex-col items-start gap-6 self-stretch rounded-card-shape bg-warm-neutral-100 p-card-padding-large">
        <div className="flex flex-col items-start gap-4 self-stretch">
          <h3 className="typography-display-4">{title}</h3>
          <div className="flex flex-col items-start gap-4">
            {availableJobs.map((job: OpenJob, index: number) => (
              <a
                key={job.hostedUrl || index}
                href={job.hostedUrl}
                className="justify-content flex flex-col items-start py-2"
              >
                <div className="typography-button-md mb-2 flex items-center justify-center gap-2 text-primary-variant">
                  {job.text}
                </div>
                <div className="typography-button-text-links-body-3 text-primary-variant">
                  {`${job.categories?.location ?? ''}`}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
